import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Header = styled.div`
  display: flex;
  flex-direction: column;
`;
